import { Injectable } from '@angular/core';
import { ModalComponent } from '../components/modal/modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private modals: { [key: string]: ModalComponent } = {};

  register(id: string, modal: ModalComponent): void {
    this.modals[id] = modal;
  }

  unregister(id: string): void {
    delete this.modals[id];
  }

  open(id: string): void {
    const modal = this.modals[id];
    modal?.open();
  }

  close(id: string): void {
    const modal = this.modals[id];
    modal?.close();
  }
}
